import React from 'react';
import { change } from 'redux-form';
import { Switch } from 'legacy-packages/ft-cb';
import './index.scss';

/**
 * Wrapper for Switch component to use with ReduxForm.
 * */
const SwitchField = (props) => {
  const {
    input: { name: fieldName },
    meta: { form, dispatch },
    otherProps,
  } = props;

  const handleToggle = (checked) => {
    const value = checked ? 'STANDARD' : 'NONE';
    dispatch(change(form, fieldName, value));
  };

  return (
    <Switch
      toggleCallback={(checked) => handleToggle(checked)}
      {...otherProps}
    />
  );
};

SwitchField.displayName = 'SwitchField';

export default SwitchField;
